var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"color":"secondary","large":"","loading":_vm.loading,"disabled":_vm.loading},on:{"click":function($event){return _vm.anular()}}},[_c('div',[_c('v-icon',[_vm._v("mdi-text-box-remove")]),_c('div',[_vm._v("ANULAR")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }